import { Link } from "react-router-dom";
import Polygon from "../../assets/img/Polygon 5.png";

const Footer = ({ ChangeCle }) => {
  return (
    <>
      {/* <div className="ct_scroll_top" onClick={() => {
        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
      }}>
        <i class="fa-solid fa-chevron-up"></i>
      </div> */}
      <footer className={ChangeCle = ChangeCle ? "footer  ct_footer_white" : "footer"}>
        {/* <img src={Polygon} /> */}
        <div className="footer_bottom">
          <nav class="navbar navbar-expand-lg navbar-light bg-light  justify-content-center">
            <ul class="navbar-nav">
              <li class="nav-item">
                <Link to={"/terms-of-use"} className="nav-link">Terms  Conditions</Link>
              </li>
              <li class="nav-item">
                <Link to={"/privacy-policy"} className="nav-link">Privacy Policy</Link>
              </li>
              <li class="nav-item">
                <Link to={"/refund-policy"} className="nav-link">Refund Policy</Link>
              </li>

            </ul>
          </nav>
        </div>
      </footer>
    </>
  );
};

export default Footer;
